import React from "react";
import TabellaOrariAcq from "./TabellaOrariAcq";
import TabellaOrariAvv from "./TabellaOrariAvv";
import TabellaOrariBR from "./TabellaOrariBR";
import TabellaOrariAdulti from "./TabellaOrariAdulti";
import "../../styles/AccordionEstivi.css"
import TabellaOrariPreParto from "./TabellaPreParto";
import TabellaOrariPreAgo from "./TabellaPreAgo";
import Space from "../../commons/Space";
import FitnessLegenda from "../fitness/FitnessLegenda";
import {Navigate} from "react-router";
import {NavLink} from "react-router-dom";
import SpaceL from "../../commons/SpaceL";


function NuotoCorsiSezioni() {
    return (
        <div className="accordion estivi d-flex flex-column m-auto" id="accordionFlushExample" style={{}}>
            <div className="accordion-item">
                <h2 className="accordion-header d-flex flex-row flex-wrap" id="flush-headingOne" style={{ justifyContent: "center", textAlign: "center" }}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne" style={{ backgroundColor: "rgb(47,113,157)" }}>
                        ACQUATICITÀ e AVVIAMENTO <br className="d-block d-sm-none"></br> (6 mesi - 5 anni)
                    </button>

                </h2>
                <div id="flush-collapseOne" className="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample" >
                    <div className="accordion-body" >
                        <div className="d-flex flex-row flex-wrap" style={{display: "flex", flexDirection: "row"}}>
                            <table className="table text-center m-auto" style={{width: "90%", maxWidth: "30em"}}>
                                <thead>
                                    <th style={{fontSize:"20px"}} colSpan={2} className="" scope="col">Sabato</th>
                                <tr>
                                    <th className="" scope="col">Acquaticità</th>
                                    <th className="" scope="col">Avviamento</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td className="data-cell">9:45 <br className="d-sm-none"/> - <br className="d-sm-none"/> 10:25</td>
                                    <td className="data-cell">10:30 <br className="d-sm-none"/> - <br className="d-sm-none"/> 11:10</td>
                                </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
            </div>
            <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingTwo">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo" style={{ backgroundColor: "#2f719d"}}>
                        NUOTO BAMBINI E RAGAZZI <br className="d-block d-sm-none"></br> (6 - 14 anni)
                    </button>
                </h2>
                <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                        <div className="table-container">
                            <table className="table text-center m-auto" style={{width: "90%"}}>
                                <thead>
                                <tr>
                                    <th className="" scope="col">Lun</th>
                                    <th className="" scope="col">Mar</th>
                                    <th className="" scope="col">Mer</th>
                                    <th className="" scope="col">Gio</th>
                                    <th className="" scope="col">Ven</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td className="data-cell">17:45 <br className="d-sm-none"/> - <br className="d-sm-none"/> 18.30
                                    <br/> (dai 10 anni)
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td className="data-cell">17:45 <br className="d-sm-none"/> - <br className="d-sm-none"/> 18.30
                                        <br/> (dai 10 anni)
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td className="data-cell">18:30 <br className="d-sm-none"/> - <br className="d-sm-none"/> 19.15</td>
                                    <td className="data-cell">18:30 <br className="d-sm-none"/> - <br className="d-sm-none"/> 19.15</td>
                                    <td className="data-cell">18:30 <br className="d-sm-none"/> - <br className="d-sm-none"/> 19.15</td>
                                    <td className="data-cell">18:30 <br className="d-sm-none"/> - <br className="d-sm-none"/> 19.15</td>
                                    <td className="data-cell">18:30 <br className="d-sm-none"/> - <br className="d-sm-none"/> 19.15</td>
                                </tr>
                                </tbody>
                            </table>
                            <div></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingThree">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree" style={{ backgroundColor: "#2f719d"}}>
                        NUOTO ADULTI
                    </button>
                </h2>
                <div id="flush-collapseThree" className="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                        <div className="table-container">
                            <table className="table text-center m-auto" style={{width: "90%", maxWidth: "50em"}}>
                                <thead>
                                <tr>
                                    <th className="" scope="col" style={{width: "20%" }}>Lun</th>
                                    <th className="" scope="col" style={{width: "20%" }}>Mar</th>
                                    <th className="" scope="col" style={{width: "20%" }}>Mer</th>
                                    <th className="" scope="col" style={{width: "20%" }}>Gio</th>
                                    <th className="" scope="col" style={{width: "20%" }}>Ven</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td className="data-cell"></td>
                                    <td className="data-cell">11:55 <br className="d-sm-none"/> - <br className="d-sm-none"/> 12:40</td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell">11:55 <br className="d-sm-none"/> - <br className="d-sm-none"/> 12:40</td>
                                </tr>
                                <tr>
                                    <td className="data-cell"></td>
                                    <td className="data-cell">12:45 <br className="d-sm-none"/> - <br className="d-sm-none"/> 13:30</td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell">12:45 <br className="d-sm-none"/> - <br className="d-sm-none"/> 13:30</td>
                                </tr>
                                <tr>
                                    <td className="data-cell">17:45 <br className="d-sm-none"/> - <br className="d-sm-none"/> 18:30</td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell">17:45 <br className="d-sm-none"/> - <br className="d-sm-none"/> 18:30</td>
                                    <td className="data-cell"></td>
                                </tr>
                                <tr>
                                    <td className="data-cell">19.15 <br className="d-sm-none"/> - <br className="d-sm-none"/> 20:00</td>
                                    <td className="data-cell">19.15 <br className="d-sm-none"/> - <br className="d-sm-none"/> 20:00</td>
                                    <td className="data-cell">19.15 <br className="d-sm-none"/> - <br className="d-sm-none"/> 20:00</td>
                                    <td className="data-cell">19.15 <br className="d-sm-none"/> - <br className="d-sm-none"/> 20:00</td>
                                    <td className="data-cell">19.15 <br className="d-sm-none"/> - <br className="d-sm-none"/> 20:00</td>
                                </tr>
                                </tbody>
                            </table>
                            <div></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingFour">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour" style={{ backgroundColor: "#2f719d" }}>
                        CORSO PREPARTO
                    </button>
                </h2>
                <div id="flush-collapseFour" className="accordion-collapse collapse" aria-labelledby="flush-headingFour" data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body" style={{}}>
                        <div className="table-container" style={{display: "flex", flexDirection: "row"}}>
                            <table className="table text-center m-auto" style={{width: "90%", maxWidth: "30em"}}>
                                <thead>
                                <tr>
                                    <th className="" scope="col">Mer</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td className="data-cell">10:45 - 11:45</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <p className="text-center" style={{marginTop: "2em"}}>
                            Il corso prevede una parte di ginnastica a secco e una parte in vasca (acqua alta e acqua bassa)
                            <br/>
                            si richiede buona capacità di galleggiamento
                            <br/>
                            <br/>
                            <b>cosa portare?</b>
                            <br/>
                            abbigliamento ginnico, costume, cuffia, asciugamano, ciabatte
                            <br/>
                            <br/>
                            *richiesto certificato ginecologico
                        </p>
                    </div>
                </div>
            </div>
            <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingFive">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive" style={{ backgroundColor: "#2f719d"}}>
                        ACQUAFITNESS
                    </button>
                </h2>
                <div id="flush-collapseFive" className="accordion-collapse collapse" aria-labelledby="flush-headingFive" data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                        <div className="table-container">
                            <table className="table text-center m-auto" style={{maxWidth: "40em"}}>
                                <tbody>
                                <tr>
                                    <td className="data-cell"></td>
                                    <td className="data-cell" style={{fontFamily: "Hammersmith One", fontSize: "22px"}} colSpan={2}>Mattino</td>
                                    <td className="data-cell"></td>
                                </tr>
                                <tr>
                                    <th className="" scope="col">Lun</th>
                                    <th className="" scope="col">Mer</th>
                                    <th className="" scope="col">Gio</th>
                                    <th className="" scope="col">Sab</th>
                                </tr>
                                <tr>
                                    <td className="data-cell">
                                        10:00 - 10:45
                                    </td>
                                    <td className="data-cell">
                                        10:00 - 10:45
                                    </td>
                                    <td className="data-cell">
                                        10:00 - 10:45
                                    </td>
                                    <td className="data-cell">
                                        10:15 - 11:00
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <table className="table text-center m-auto" style={{maxWidth: "40em"}}>
                                <tbody>
                                <tr>
                                    <td className="data-cell"></td>
                                    <td className="data-cell" style={{fontFamily: "Hammersmith One", fontSize: "22px"}} colSpan={1}>Intervallo</td>
                                    <td className="data-cell"></td>
                                </tr>
                                <tr>
                                    <th className="" scope="col">Lun</th>
                                    <th className="" scope="col">Mer</th>
                                    <th className="" scope="col">Gio</th>
                                </tr>
                                <tr>
                                    <td className="data-cell">
                                        12:40 - 13:25<br/> <a style={{fontSize: "12px"}}>(fino al 23/06)</a>
                                    </td>
                                    <td className="data-cell">
                                        13:00 - 14:15 <br/> <a style={{fontSize: "12px"}}>(da confermare)</a>
                                    </td>
                                    <td className="data-cell">
                                        12:40 - 13:25<br/> <a style={{fontSize: "12px"}}>(fino al 26/06)</a>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="data-cell">
                                        13:30 - 14:15<br/> <a style={{fontSize: "12px"}}>(fino al 23/06)</a>
                                    </td>
                                    <td className="data-cell">
                                        12:30 - 13:30 <br/> <a style={{fontSize: "12px"}}>(fino al 25/06)</a>
                                    </td>
                                    <td className="data-cell">
                                        13:30 - 14:15<br/> <a style={{fontSize: "12px"}}>(fino al 26/06)</a>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="data-cell">

                                    </td>
                                    <td className="data-cell">
                                        13:30 - 14:30 <br/> <a style={{fontSize: "12px"}}>(fino al 25/06)</a>
                                    </td>
                                    <td className="data-cell">

                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <table className="table text-center m-auto" style={{maxWidth: "40em"}}>
                                <tbody>
                                <tr>
                                    <td className="data-cell" style={{fontFamily: "Hammersmith One", fontSize: "22px"}} colSpan={1}>Sera</td>
                                </tr>
                                <tr>
                                    <th className="" scope="col">Mer</th>
                                </tr>
                                <tr>
                                    <td className="data-cell">
                                        19:15 - 20:00
                                    </td>
                                </tr>
                                <tr>
                                    <td className="data-cell">
                                        20:00 - 20:45
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingSix">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSix" aria-expanded="false" aria-controls="flush-collapseSix" style={{ backgroundColor: "#2f719d"}}>
                        FITNESS
                    </button>
                </h2>
                <div id="flush-collapseSix" className="accordion-collapse collapse" aria-labelledby="flush-headingSix" data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                        <div className="table-container">
                            <table className="table text-center m-auto" style={{ width: "90%" }}>
                                <thead>
                                <tr>
                                    <th scope="col">Lun</th>
                                    <th scope="col">Mar</th>
                                    <th scope="col">Mer</th>
                                    <th scope="col">Gio</th>
                                    <th scope="col">Ven</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td className="data-cell">9:00 - 10:00 <br /> <a style={{ color: "black" }}>Stretching Pilates</a></td>
                                    <td className="data-cell">9:00 - 10:00 <br /> <a style={{ color: "black" }}>Total Body</a></td>
                                    <td className="data-cell">9:00 - 10:00 <br /> <a style={{ color: "black" }}>Up Body</a></td>
                                    <td className="data-cell">9:00 - 10:00 <br /> <a style={{ color: "black" }}>Postural Pilates</a></td>
                                    <td className="data-cell">9:00 - 10:00 <br /> <a style={{ color: "black" }}>Pilates</a></td>
                                </tr>
                                <tr>
                                    <td className="data-cell">10:00 - 11:00 <br /> <a style={{ color: "black" }}>Stretching Pilates</a></td>
                                    <td className="data-cell">10:00 -11:00 <br /> <a style={{ color: "black" }}>Stretching</a></td>
                                    <td className="data-cell">10:00 -11:00 <br /> <a style={{ color: "black" }}>Leg Crash</a></td>
                                    <td className="data-cell">10:00 -11:00 <br /> <a style={{ color: "black" }}>Postural Pilates</a></td>
                                    <td className="data-cell">10:00 -11:00 <br /> <a style={{ color: "black" }}>Functional Training</a></td>
                                </tr>
                                <tr>
                                    <td className="data-cell">12:40 - 13:30 <br /> <a style={{ color: "black" }}>Pilates</a></td>
                                    <td className="data-cell">12:40 - 13:30 <br /> <a style={{ color: "black" }}>GAG</a></td>
                                    <td className="data-cell">12:00 - 13:00 <br /> <a style={{ color: "black" }}>Hatha Yoga</a></td>
                                    <td className="data-cell">12:40 - 13:30 <br /> <a style={{ color: "black" }}>Functional Training</a></td>
                                    <td className="data-cell">13:00 - 14:00 <br /> <a style={{ color: "black" }}>Hatha Yoga</a></td>
                                </tr>
                                <tr>
                                    <td className="data-cell">13:30 - 14:20 <br /> <a style={{ color: "black" }}>Total Body</a></td>
                                    <td className="data-cell">13:30 - 14:20 <br /> <a style={{ color: "black" }}>Stretching Mobility</a></td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell">13:30 - 14:20 <br /> <a style={{ color: "black" }}>Pilates</a></td>
                                    <td className="data-cell"></td>
                                </tr>
                                <tr>
                                    <td className="data-cell">19:00 - 19:50 <br /> <a style={{ color: "black" }}>Fit Boxe</a></td>
                                    <td className="data-cell">19:00 - 19:50 <br /> <a style={{ color: "black" }}>Functional Training</a></td>
                                    <td className="data-cell">19:00 - 19:50 <br /> <a style={{ color: "black" }}>Stretching Pilates</a></td>
                                    <td className="data-cell">19:00 - 19:50 <br /> <a style={{ color: "black" }}>Total Body</a></td>
                                    <td className="data-cell">19:00 - 19:50 <br /> <a style={{ color: "black" }}>Functional Training</a></td>
                                </tr>
                                <tr>
                                    <td className="data-cell">19:50 - 20:40 <br /> <a style={{ color: "black" }}>Functional Training</a></td>
                                    <td className="data-cell">19:50 - 20:40 <br /> <a style={{ color: "black" }}>Pilates</a></td>
                                    <td className="data-cell">20:00 - 21:00 <br /> <a style={{ color: "black" }}>Hatha Yoga</a></td>
                                    <td className="data-cell">19:50 - 20:40 <br /> <a style={{ color: "black" }}>Zumba</a></td>
                                    <td className="data-cell">19:50 - 20:40 <br /> <a style={{ color: "black" }}>Pilates</a></td>
                                </tr>
                                </tbody>
                            </table>

                        </div>


                    </div>
                </div>
            </div>
        </div>
    )
}

export default NuotoCorsiSezioni;
